import { render, staticRenderFns } from "./BatchPriceTable.vue?vue&type=template&id=3a572148&"
import script from "./BatchPriceTable.vue?vue&type=script&lang=js&"
export * from "./BatchPriceTable.vue?vue&type=script&lang=js&"
import style0 from "./BatchPriceTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports